module.exports = __webpack_public_path__ + "img/product_39.5da656d.webp";